import ActionTypes from '../Actions/ActionTypes';

let initialState = {
    chatList: [],
    chatRooms: [],
    vendorMessages: [],
    chatMessages: [],
    chatObject: null,
    guestList: [],
    vendorList: [],
};

const ChatReducer = (state = initialState, action) => {
    switch (action.type) {


        case ActionTypes.GET_CHAT_ROOM:
            state = { ...state, chatRooms: action.payload };
            break;

        case ActionTypes.GET_CHAT_LIST:
            state = { ...state, chatList: action.payload };
            break;

        case ActionTypes.GET_VENDOR_MESSAGES:
            state = { ...state, vendorMessages: action.payload };
            break;

        case ActionTypes.GET_CHAT_MESSAGES:
            let chat_messages_list_copy = [];
            chat_messages_list_copy = [
                ...state.chatMessages,
                ...action.payload.messages?.data
            ];
            state = {
                ...state,
                chatObject: action.payload,
                chatMessages: chat_messages_list_copy,
            };
            break;

        case ActionTypes.GET_MESSAGES:
            let _messages_list_copy = [];
            _messages_list_copy = [
                ...state.chatMessages,
                ...action.payload?.data
            ];
            state = {
                ...state,
                chatObject: action.payload,
                chatMessages: _messages_list_copy,
            };
            break;

        case ActionTypes.UPDATE_CHAT_MESSAGES:
            let messagesCopy = [...state.chatMessages];
            let messageExist = messagesCopy?.findIndex((item) => item?.id == action.payload?.id) != -1
                ? true
                : false
            if (!messageExist) {
                messagesCopy.unshift(action.payload);
                state = { ...state, chatMessages: messagesCopy };
            }
            break;


        case ActionTypes.RESET_CHAT:
            state = {
                ...state,
                chatMessages: [],
                chatObject: null
            }
            break;
        case ActionTypes.GET_GUEST_LIST:
            state = { ...state, guestList: action.payload };
            break;
        case ActionTypes.GET_VENDOR_LIST:
            state = { ...state, vendorList: action.payload };
            break;


        default:
            break;
    }
    return state;
};

export default ChatReducer;
